// extracted by mini-css-extract-plugin
export default {"emojiClass":"Chat_emojiClass__2aZc7"};